import styled from "@emotion/styled";
import { timelineColors } from "../theme/config";

export const BottomWrapper = styled.div`
  width: 100%;
  align-self: center;
  border-top: 1px solid ${timelineColors.border};
  height: 100%;
  background-color: #fff;
`;

export const ContentWrapper = styled.div<{ height: number }>`
  display: inline-flex;
  min-height: ${({ height }) => height}px;
  border-top: 1px solid ${timelineColors.border};
`;

export const PlayerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;

  overflow: auto;
  padding: 0px 0px;
`;
